var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:[{
        'box-layout': _vm.boxLayout,
        'collapse-sidebar': _vm.collapseSidebar,
        'rtl-layout': _vm.rtlLayout
    }, _vm.envClass],attrs:{"dark":_vm.darkMode,"id":"inspire"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }